import styled from 'astroturf/react';

const Field = styled('label')`
  position: relative;
  display: flex;
  width: 100%;
  line-height: 1.43;
`;

const FieldLabel = styled('div')`
font-size: var(--ph-text-sm);
display: flex;
justify-content: space-between;
flex: 0 0 30%;
align-items: flex-start;
color: var(--ph-gray-500);
min-width: 100px;
`;

const FieldText = styled('div')`
  flex: initial;
  font-size: var(--ph-text-sm);
  color: var(--black);

  &.status-red {
    border-radius: var(--ph-border-radius-sm);
    color: var(--white);
    background-color: var(--ph-red-500);
    padding: 5px 10px;
  }

  &.status-yellow {
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-yellow-500);
    padding: 5px 10px;
  }

  &.status-green {
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-green-500);
    padding: 5px 10px;
  }
`;

export default {
  Field,
  FieldLabel,
  FieldText,
};
